import { DateTime } from 'luxon';
import React, { useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import { FaBell } from 'react-icons/fa';
import { func, string } from 'prop-types';

function StackedToast({ id, text, isoTime, bg, onClose }) {
    // const { appContext } = useContext(AppContext);
    const [show, setShow] = useState(true);
    const handleClose = () => {
        setShow(false);
        onClose(id);
    };
    return (<Toast
        autohide={true}
        show={show}
        onClose={handleClose}
        bg={bg ?? 'light'}>
        <Toast.Header>
            <FaBell
                size={'25px'} />
            <strong
                className={'me-auto rounded p-2'}>Notification</strong>
            <small
                className={'text-muted'}>
                {DateTime.fromISO(isoTime)
                    .setZone('local').toLocaleString(DateTime.TIME_SIMPLE)} (Local Time)
            </small>
        </Toast.Header>
        <Toast.Body>{text}</Toast.Body>
    </Toast>);
}

StackedToast.propTypes = {
    id: string,
    text: string,
    isoTime: string,
    bg: string,
    onClose: func,
};

export default StackedToast;